import { Entity } from '@/store/shared/entity'

export default class DeclareProductList extends Entity<number>{
        //报关id（外键）
        declareCustomsId:number;        
        //总品名id（外键）
        declareGroupId:number;        
        //品名标识
        productId:number = undefined;        
        //海关编号
        productCode:string = undefined;        
        //品名中文
        productName:string = undefined;        
        //品名英文
        productNameEn:string = undefined;        
        //箱数
        boxCount:number = null;        
        //数量
        quantity:number = null;        
        //发货人id
        unit:string = undefined;        
        //每箱毛重
        grossWeight:number = null;        
        //毛重
        totalGrossWeight:number = null;        
        //每箱净重
        netWeight:number = null;        
        //净重
        totalNetWeight:number = null;        
        //单价
        price:number = null;        
        //总价
        totalAmount:number = null;
        // 工厂ID
        factoryId:number = 0;
        // 工厂名称（展示）
        factoryName:string = undefined;
        // 境内货源地
        domesticSourceOfGood:string = undefined;
        // 人民币金额
        rmbAmount:number = null;
              //项号
        itemIndexNumber:number;  
        itemIndexNumberOld:number; 
}

